import { inject, Injectable, signal, WritableSignal } from '@angular/core';

import { DavinciSsoScenario } from '@ph-core/services/auth/auth-sso-attempt.model';
import { readDavinciSsoDefer } from '@ph-core/services/auth/auth-sso-defer';
import { ConfigService } from '@ph-core/services/config/config.service';
import { notificationDefaultDuration } from '@ph-static-data/notification-durations';

interface ErrorState {
  status: string;
  message: string;
  show: boolean;
  duration?: number;
  ssoScenario?: DavinciSsoScenario | null;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private configService = inject(ConfigService);

  error: WritableSignal<ErrorState> = signal({
    status: '',
    message: '',
    show: false,
    duration: notificationDefaultDuration,
    ssoScenario: null,
  });

  displayErrorMessage(status: number, text: string, duration: number = notificationDefaultDuration): void {
    this.error.set({
      status: (status && status.toString()) || '',
      message: text,
      show: true,
      duration,
      ssoScenario: null,
    });
  }

  displaySsoError(
    scenario: DavinciSsoScenario,
    message = '',
    duration: number = notificationDefaultDuration
  ): void {
    this.error.set({
      status: '401',
      message,
      show: true,
      duration,
      ssoScenario: scenario,
    });
  }

  hideErrorMessage(): void {
    // ponytail: interceptor 200s (layout/prismic) must not wipe SSO copy on F5. Ceiling: a hide
    // that must run while the defer is still stored needs clearDavinciSsoDefer first (logout already does).
    if (readDavinciSsoDefer(this.configService.environment.application)) {
      return;
    }

    this.error.set({ status: '', message: '', show: false, ssoScenario: null });
  }
}
